import { AssigneeType } from './types';

export const assigneeTypeLookup = {
  [AssigneeType.BOOKKEEPING_PORTFOLIO_ASSOCIATE]: 'BPA',
  [AssigneeType.BOOKKEEPER]: 'BK',
  [AssigneeType.SPECIALIST]: 'SP',
  [AssigneeType.CLIENT]: 'CL',
};
